/*
 * Login.js
 * --------
 * Email + password sign-in. On success the AuthContext holds the user and we
 * send them to their dashboard.
 */

import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errorMessage } from "../api/client";
import useTheme from "../useTheme";
import { SITE_THEME_COLOR } from "../theme";
import "../styles/Auth.css";

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  /* Set when a visitor was sent here mid-flow, e.g. to escalate a question. */
  const next = params.get("next") || "/dashboard";

  useTheme(SITE_THEME_COLOR);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await login(email, password);
      navigate(next);
    } catch (err) {
      setError(errorMessage(err, "Could not sign in."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1 className="auth-title">&gt; SIGN_IN</h1>
        <p className="auth-subtitle">Access your portfolio agent.</p>

        <div className="auth-field">
          <label className="auth-label" htmlFor="email">Email</label>
          <input
            id="email"
            className="auth-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>

        <div className="auth-field">
          <label className="auth-label" htmlFor="password">Password</label>
          <input
            id="password"
            className="auth-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && <p className="auth-error">{error}</p>}

        <button className="auth-btn" type="submit" disabled={loading}>
          {loading ? "SIGNING IN..." : "SIGN IN"}
        </button>

        <p className="auth-note">
          No account? <Link className="auth-link" to="/signup">Create one</Link>
        </p>
      </form>
    </div>
  );
}

export default Login;
